module.exports = __webpack_public_path__ + "static/img/banner03.fffbede5.png";